import React, { useContext, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { faCamera } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SocketContext } from '../../../../socketProvider';
import { post } from '../../../../helpers/fetch';
import { buildURL } from '../../../../helpers/urls';
import { displayErrorModal } from '../../../../helpers/swal';

import RoundButton from '../../../../components/RoundButton';
import Authorize from '../../../../components/Authorize';
import { ban } from '../../../../helpers/api';

import { openKickDialog, openBanDialog } from './warningDialogs';
import { showWarnPopup } from '../../MonitorNav/Notifications/Notification/WarnBtn/actions';
import { MAGICSHOTS_WRITE } from '../../../../components/Authorize/permissions/resources';

import style from './style.module.scss';

const Controls = ({
  cameraName,
  queue = [],
  showWarnPopupAction,
}) => {
  const socket = useContext(SocketContext);
  const dialogRef = useRef();

  const kickBtnHandler = () => {
    dialogRef.current = openKickDialog(() => {
      socket.emit('boot user', queue[0]);
    });
  };

  const banBtnHandler = () => openBanDialog(() => {
    if (!queue[0]) {
      return;
    }
    ban({ userId: queue[0], banStatus: true }).catch((err) => {
      console.error(err);
      displayErrorModal();
    });
  });

  const warnBtnHandler = () => {
    if (queue[0]) {
      showWarnPopupAction(queue[0]);
    }
  };

  useEffect(() => {
    if (dialogRef.current) {
      dialogRef.current.close();
      dialogRef.current = null;
    }
  }, [queue]);

  const takeMagicshotHandler = async () => {
    try {
      await post(buildURL('pushToQueue'), { camId: cameraName });
      toast('Taking Magicshot', { containerId: 'magicshot' });
    } catch (e) {
      displayErrorModal({
        title: 'Error taking magicshot',
        text: e.body?.error || e.message,
        timer: 5000,
      });
    }
  };

  return (
    <div className={style.controls}>
      <Authorize permissions={MAGICSHOTS_WRITE}>
        <RoundButton className={style.cameraBtn} onClick={takeMagicshotHandler}>
          <FontAwesomeIcon size="lg" icon={faCamera} className="align-middle" />
        </RoundButton>
      </Authorize>
      <div className={style.separator} />
      {queue.length > 0 && (
        <>
          <RoundButton onClick={warnBtnHandler}>
            Warn
          </RoundButton>
          <RoundButton onClick={kickBtnHandler}>
            Kick
          </RoundButton>
          <RoundButton onClick={banBtnHandler}>
            Ban
          </RoundButton>
        </>
      )}
    </div>
  );
};

export default connect(
  ({
    cameras: {
      queue,
    },
  }, {
    cameraName,
  }) => ({
    cameraName,
    queue: queue[cameraName],
  }),
  {
    showWarnPopupAction: showWarnPopup,
  },
)(Controls);
